import { useStaticQuery, graphql } from "gatsby"

export const useSchoolImages = () => {
  const data = useStaticQuery(graphql`
    query {
      _001_small: file(relativePath: { eq: "img/school/small001-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 800, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      _002_small: file(relativePath: { eq: "img/school/small002-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 800, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      _003_small: file(relativePath: { eq: "img/school/small003-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 800, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
        
      _004_small: file(relativePath: { eq: "img/school/small004-min.png" }) {
        childImageSharp {
          fluid(maxWidth: 800, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      } 
        
      _001_big: file(relativePath: { eq: "img/school/logo-ministerstwo-kultury.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 1686, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
    }
  `)
  return data
}
